import { get } from "lodash";
import { PRICER_TYPES, PRICING_MODES } from "utils/constants";

const composableModes = [PRICING_MODES.COMPOSABLE, PRICER_TYPES.COMPOSABLE];

export const planPricingMode = (config, pricerType) =>
  composableModes.includes(get(config, "pricing.mode", pricerType))
    ? PRICING_MODES.COMPOSABLE
    : PRICING_MODES.PACKAGED;

export const withPricingMode = (config, mode) => ({
  ...(config || {}),
  pricing: { ...get(config, "pricing"), mode },
});
